// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hE1kT","colBig":"styles_colBig__3QBgS","colSmall":"styles_colSmall__1zgAO"};